import RegisterForm from './RegisterFormContainer';

export default RegisterForm;
